// extracted by mini-css-extract-plugin
export var dot = "customer-journey-timeline-module--dot--7adfd";
export var firstStep = "customer-journey-timeline-module--firstStep--4e2b2";
export var hide = "customer-journey-timeline-module--hide--73c45";
export var imagePlaceholder = "customer-journey-timeline-module--imagePlaceholder--55619";
export var journeyContainer = "customer-journey-timeline-module--journeyContainer--b1287";
export var journeyStep = "customer-journey-timeline-module--journeyStep--54c41";
export var journeyStepContent = "customer-journey-timeline-module--journeyStepContent--c864a";
export var lastStep = "customer-journey-timeline-module--lastStep--f4026";
export var reverse = "customer-journey-timeline-module--reverse--3cf49";
export var ruler = "customer-journey-timeline-module--ruler--d4492";
export var stepConnector = "customer-journey-timeline-module--stepConnector--aad4d";
export var stepContent = "customer-journey-timeline-module--stepContent--14cd6";
export var stepMainContent = "customer-journey-timeline-module--stepMainContent--c2e30";
export var stepNumber = "customer-journey-timeline-module--stepNumber--fda04";